import React, { FC } from "react";
import ImagePreview, { ImagePreviewProps } from "@/components/MediaPreview/ImagePreview";

export const DMPreview: FC<ImagePreviewProps> = (props) => <ImagePreview {...props} />;

export default DMPreview;
